import styles from './LeagueCardSkeleton.module.css'

export function LeagueCardSkeleton() {
  return (
    <div className={styles.card} aria-hidden="true">
      <div className={styles.header}>
        <div className={styles.shimmerName} />
        <div className={styles.shimmerBadge} />
      </div>
      <div className={styles.rankRow}>
        <div className={styles.shimmerRank} />
        <div className={styles.shimmerMeta} />
      </div>
      <div className={styles.strip}>
        <div className={styles.shimmerIcon} />
        <div className={styles.shimmerStripText} />
        <div className={styles.shimmerCountdown} />
      </div>
    </div>
  )
}
